export default {
  meetingItem: [],
  user: [],
};
